<template>
    <div class="authWrapper new-login-wrapper">
      <div class="container">
        <div class="row login-white-wrap whiteBG-wrap">
          <div class="col-lg-7 col-md-7 no-padding">
            <div class="login-left-wrap d-flex align-items-center justify-content-center flex-column text-center">
              <div class="spinner-border text-primary mb-3" role="status"></div>
              <h4>Logging you in...</h4>
              <p>Please wait while we log you in securely.</p>
            </div>
          </div>
          <div class="col-lg-5 col-md-5 no-padding">
            <LoginCarsoule />
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import LoginCarsoule from "./Logincarsoule.vue";
  export default {
    name: "AdminAutoLogin",
    components: {
      LoginCarsoule,
    },
    data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL
    };
  },
    mounted() {
      const switchId = this.$route.query.switchId;
      if (switchId) {
        this.autoLogin(switchId);
      }
      else {
        this.$router.replace("/login");
      }
    },
    methods: {
      async autoLogin(switchId) {
        const { switchAccountAdmin } = await import('@/utils/switchAccount');
        await switchAccountAdmin.call(this, switchId);
      },
    },
  };
  </script>
  

  <style scoped>
  .spinner-border {
    width: 3rem;
    height: 3rem;
  }
  </style>
  
  <style src="@/assets/css/authen.css"></style>
  <style src="@/assets/css/newLogin.css"></style>
  